import { Adapter } from '../adapters/Adapter';

export class Report {
  downloadPath: string;

  constructor(
    public authorId: number,
    public date: string,
    public deleted: boolean,
    public documentIndexId: number,
    public fullPath: string,
    public locationId: number,
    public name: string,
    public path: string,
    public server: string,
    public title: string,
    public entity?
  ) {
    this.downloadPath = this.path.substr(1).concat(this.name.replace(' ', '%20')).substr(1);
  }
}

export class ReportAdapter implements Adapter<Report> {
  adapt(item: any, entity?): Report {
    return new Report(
      item.authorId,
      item.date,
      item.deleted,
      item.documentIndexId,
      item.fullPath,
      item.locationId,
      item.name,
      item.path,
      item.server,
      item.title,
      entity
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Reports.ts